<div (click)="click()"
    class="relative inline-block w-[230px] h-[42px] cursor-pointer transition duration-300 hover:scale-[1.04] hover:brightness-125 rounded-[36px] text-white font-bold">
    <img class="absolute inset-0 w-full h-full object-cover" src="/images/button/border.svg" alt="" />
    <div
        class="relative flex items-center justify-center w-full h-full text-[16px] text-white font-outfit font-bold rounded-md">
        <span class="leading-none">{{ buttonText }}</span>
    </div>
</div>